import scrollTo from "@degjs/scroll-to";

(function () {
  const inPageNavigation = document.querySelector(".in-page-navigation");
  if (!inPageNavigation) {
    return;
  }
  
  const HEADER_HEIGHT = 120;
  const FOCUS_AREA_HEIGHT = 300;
  const ACTIVE_NAV_LINK_CLASS = "in-page-navigation-link-active";
  const headingPositions = {};
  
  const getHeadingPosition = (headingEl) => headingEl.getBoundingClientRect().top + document.documentElement.scrollTop;
  
  function customScrollTo(linkHref, e) {
    e.preventDefault();
    const headingToScrollTo = document.getElementById(linkHref);
    
    scrollTo({
      position: getHeadingPosition(headingToScrollTo) - HEADER_HEIGHT - 1, // 1px to make sure the correct item is shown as active in the nav
      duration: 500,
      easing: 'easeInOut'
    });
  }
  
  function createNavigationItem(name, key, i) {
    const li = document.createElement("li");
    const anchor = document.createElement("a");
    anchor.href = `#${key}`;
    anchor.innerText = name;
    
    if (i === 0) {
      anchor.classList.add(ACTIVE_NAV_LINK_CLASS);
    }
    
    anchor.addEventListener("click", (e) => {
      customScrollTo(key, e);
    });
    
    li.appendChild(anchor);
    inPageNavigation.querySelector("ul").appendChild(li);
  }
  
  function getSectionHeadings() {
    const headings = document.querySelectorAll(".js--inpage-navigation-section h2");
    return Array.from(headings).filter(
      (heading) => !heading.closest(".card-content-swiper__items")
    );
  }

  function compileNavigationItems() {
    const inPageNavigationSections = getSectionHeadings();

    if (inPageNavigationSections.length) {
      inPageNavigationSections.forEach((sectionHeading, i) => {
        const name = sectionHeading.innerText;
        const key = "id_" + name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase() + "-" + i;
        headingPositions[key] = getHeadingPosition(sectionHeading);
        sectionHeading.id = key;
        createNavigationItem(name, key, i);
      });
    } else {
      inPageNavigation.style.display = "none";
    }
  }
  
  function removeCurrentActiveIndicator() {
    const activeLink = document.querySelector(`.${ACTIVE_NAV_LINK_CLASS}`);
    if (activeLink) {
      activeLink.classList.remove(ACTIVE_NAV_LINK_CLASS);
    }
  }
  
  function setActiveIndicator(key) {
    removeCurrentActiveIndicator();
    document.querySelector('a[href*=' + key + ']').classList.add(ACTIVE_NAV_LINK_CLASS);
  }
  
  /**
   * Checks if the heading is inside of the focus part of the viewport: the x pixels high area below the area that is
   * reserved for the header (that is positioned fixed when scrolling upwards).
   **/
  function isInFocus(headingKey) {
    const headingPos = headingPositions[headingKey];
    const topOfFocusArea = document.documentElement.scrollTop + HEADER_HEIGHT;
    const bottomOfFocusArea = document.documentElement.scrollTop + HEADER_HEIGHT + FOCUS_AREA_HEIGHT;
    return headingPos >= topOfFocusArea && headingPos <= bottomOfFocusArea;
  }
  
  function handleScroll() {
    /** If at the bottom of the page, always make sure the last item is active: **/
    const isAtTheBottom = (window.innerHeight + window.scrollY) >= document.body.scrollHeight;
    if (isAtTheBottom) {
      const lastKey = Object.keys(headingPositions).pop()
      setActiveIndicator(lastKey);
      return;
    }
    
    for (const headingKey in headingPositions) {
      if (isInFocus(headingKey)) {
        setActiveIndicator(headingKey);
        return;
      }
    }
  }
  
  compileNavigationItems();
  document.addEventListener("scroll", handleScroll);
})();